import CardWithdrawalAsset from './CardWithdrawalAsset';

export default CardWithdrawalAsset;
